import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  modalSpacing: {
    padding: '2.4rem 6.4rem 4rem 6.4rem',
  },
  body: {
    width: '100%',
    textAlign: 'center',
    '@media(max-width: 450px)': {
      width: 'auto',
    },
  },
  title: {
    margin: 0,
    textAlign: 'center',
    font: {
      weight: 700,
      size: '2.8rem',
      lineHeight: '4rem',
    },
    marginBottom: '1.6rem',
  },
  form: { marginBottom: '4.6rem' },
  formSelect: { width: '50%', margin: '3.6rem auto 0', textAlign: 'left' },
  footer: {
    margin: [0],
    marginTop: '0.4rem',
    padding: { top: '4rem' },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderTop: `0.1rem solid ${colors.neutral[300]}`,
  },
  actionsBlock: {
    margin: 0,
    display: 'flex',
    justifyContent: 'space-between',
  },
  actionBlockTitle: {
    font: {
      size: '2rem',
      lineHeight: '2.8rem',
      weight: 700,
    },
    borderTop: `0.1rem solid ${colors.neutral[300]}`,
    textAlign: 'center',
    padding: { top: '3.2rem', bottom: '0.8rem' },
    marginBottom: 0,
  },
  actionBlockCaption: {
    margin: { bottom: '4rem' },
    color: colors.neutral[700],
    font: { size: '1.6rem', lineHeight: '2.4rem' },
    textAlign: 'center',
    '& b': {
      color: colors.neutral[900],
    },
  },
  continueButtonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: '20rem',
    marginLeft: '2rem',
  },
  errorMessage: {
    fontSize: '1.4rem',
    color: colors.red[600],
  },
  message: {
    fontSize: '1.6rem',
  },
};

const createStyles = createUseStyles(styles);

export { styles, createStyles };
